import React from 'react';
import { RecentOrderDetails } from '@thd-olt-component-react/recent-order-details';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Hydrator } from '@thd-olt-component-react/hydrator';

import classnames from 'classnames/bind';
import componentStyles from './components.module.scss';

const styles = classnames.bind(componentStyles);

export function CustomRenderedRecentOrderHistory({
  SCROLL_BUFFER,
  HOMEPAGE_DELAY_STANDARD,
  PLACEHOLDER,
}) {
  return function RecentOrderHistory() {
    return (
      <QueryProvider cachekey="recent-orders">
        <Hydrator
          id="recentOrderHistory-php-hydrator"
          className={styles('u-height-100')}
          scrollBuffer={SCROLL_BUFFER}
          delay={HOMEPAGE_DELAY_STANDARD}
          placeholder={PLACEHOLDER}
        >
          <RecentOrderDetails />
        </Hydrator>
      </QueryProvider>
    );
  };
}
